import { Component, ViewEncapsulation, input } from '@angular/core';

import { EmailInfoboxComponent } from '../../components/email-infobox/email-infobox.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailTellentLogoComponent } from '../../components/email-tellent-logo/email-tellent-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { TellentProductsFooterComponent } from '../../components/tellent-products-footer/tellent-products-footer.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  styleUrls: ['../../global-styles.less', './tellent-request-account-deletion.component.less'],
  templateUrl: './tellent-request-account-deletion.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailLinkComponent,
    EmailTellentLogoComponent,
    TellentProductsFooterComponent,
    EmailInfoboxComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
})
export class TellentRequestAccountDeletionTemplateComponent {
  public readonly data = input.required<WrappedValue<TellentRequestAccountDeletionTemplateData>>();
}

export type TellentRequestAccountDeletionTemplateData = {
  header: string;
  subheader: string;
  infobox_html: string;
  footer: {
    text: string;
    label: string;
    href: string;
    target: string;
  };
};

export const TellentRequestAccountDeletionTemplateMocks: TellentRequestAccountDeletionTemplateData[] =
  [
    {
      header: 'We deleted your account',
      subheader: 'Your account has been successfully deleted as per your request.',
      infobox_html:
        'All associated data will be <b>permanently deleted in %{days} days</b>. If you want to keep your account, please contact our support team.',
      footer: {
        text: 'Need help?',
        href: 'https://auth.tellent.com/?intercom_open=true',
        label: 'Contact us',
        target: '_blank',
      },
    },
  ];
